import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAgXRnzaxrwq8OoPqigqze3mAJP2UBdvYY",
  authDomain: "fc-dallas-20b9a.firebaseapp.com",
  projectId: "fc-dallas-20b9a",
  storageBucket: "fc-dallas-20b9a.firebasestorage.app",
  messagingSenderId: "406480691546",
  appId: "1:406480691546:web:dd81b369b4ddcec8719363"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };